import { useAccount } from '../../contexts/account/AccountContexts';

const useBilling = () => {
  const { accountResponse } = useAccount();
  return Boolean(
    accountResponse &&
      (accountResponse.addons.includes('BILLING') || accountResponse.addons.includes('TEST_BILLING'))
  );
};

export default useBilling;
